/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForVulnerabilitiesGcp extends models.GovernanceConfigurationBaseForVulnerabilities {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForVulnerabilitiesGcp");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForVulnerabilitiesGcp.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForVulnerabilitiesGcp>): GovernanceConfigurationForVulnerabilitiesGcp {
        let obj = Object.assign(new GovernanceConfigurationForVulnerabilitiesGcp(), model);
        GovernanceConfigurationForVulnerabilitiesGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForVulnerabilitiesGcp>): GovernanceConfigurationForVulnerabilitiesGcp {
        if (!model) return null;
        return GovernanceConfigurationForVulnerabilitiesGcp.newInstance(<GovernanceConfigurationForVulnerabilitiesGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForVulnerabilitiesGcp) {
        if (!obj) return;

        models.GovernanceConfigurationForVulnerabilitiesGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForVulnerabilitiesGcp): boolean {
        if (models.GovernanceConfigurationBaseForVulnerabilities.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForVulnerabilitiesGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specified whether security health analytics enabled or not
     */
    security_health_analytics_enabled: boolean;

    /**
     * Specified whether Web security scanner enabled or not
     */
    web_security_scanner_enabled: boolean;

}
